<template>
  <el-card class="box-card" shadow="never">
    <div slot="header" class="clearfix">
      <p style="display: inline-block;padding-left:92px">目录预览</p><el-button style="color:#3873fe!important;margin-left: 15px;" :loading="loading" type="text" @click="refresh">预览</el-button>
    </div>
    <el-tree v-if="show" :props="defaultProps" :data="data" style="position: absolute;top: 70px;bottom: 0px;left: 0px;right: 0px;overflow-y: auto;" >
    </el-tree>
  </el-card>
</template>

<script>
import service from "@/CommonDP/service/folder-service";
export default {
  props: {
    treeData: {
      type: Array,
      default: () => []
    },
    csgetParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultProps: {
        label: "folderName",
        children: "childrenList",
        isLeaf: "leaf"
      },
      show: false,
      loading: false,
      data: [],
      huishouzhan: {
        folderName: "回收站",
        childrenList: []
      }
    };
  },

  watch: {
    treeData() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
  created() {
  },
  methods: {
    querylist(type) {
      this.data=[];
      if(type==='refresh'){
        var tt=this.csgetParams.orderKey.split('>').every(item => {
          return this.csgetParams[item + "List"].length>0
        });
        if(tt){
          service.dynapreview(this.csgetParams).then(res => {
            if (res.result === "0") {
              this.data = res.data;
              this.data.push(this.huishouzhan)
            }
          });
        }else{
          var item=this.csgetParams.orderKey.split('>')
          for(var i=0;i<item.length;i++){
            if(!this.csgetParams[item[i] + "List"].length){
              if(item[i]==='child'){
                this.$message.warning("子项不能为空");
                break;
              }else if(item[i]==='stage'){
                this.$message.warning("阶段不能为空");
                break;
              }else if(item[i]==='spec'){
                this.$message.warning("专业不能为空");
                break;
              }
            }
          }
        }
        
      }else{
        service.dynapreview(this.csgetParams).then(res => {
          if (res.result === "0") {
            this.data = res.data;
            this.data.push(this.huishouzhan)
          }
        });
      }      
    },
    // 预览
    refresh() {
      console.log('预览');
      this.show = false;
      this.loading = true;
      this.$nextTick(() => {
        this.show = true;
        this.loading = false;
        this.querylist('refresh');
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.box-card{
  /deep/ .el-card__header{
    padding:18px 0px
  }
}
</style>
